import styled, { css } from 'styled-components';

export const MordenCard = styled.div<{ padding?: number }>`
  background: var(--card);
  border-radius: var(--radius);
  border: 1px solid var(--border);
  box-shadow: 0 1px 0 rgba(16, 24, 40, 0.04);
  overflow: hidden;
  box-sizing: border-box;
  max-width: 100%;
  ${(p) => css`
    padding: ${p.padding ?? 16}px;
  `}

  @media (max-width: 380px) {
    padding: ${(p) => Math.min(p.padding ?? 16, 12)}px;
  }
`;
